import { useRouter } from "next/router";
import React, { useContext, useEffect, useState, useTransition } from "react";
import { useForm } from 'react-hook-form'
import settingsModel from "../../models/settings.model";
import useSWR from 'swr'
import Heading from "../../components/Heading.js";
import Link from "next/link";
import SettingsLayout from "./SettingsLayout";
import Form from "react-bootstrap/Form";
const Page = function () {

    const router = useRouter()
    const {
        register,
        handleSubmit,
        watch,
        formState: { errors },
        setError,
        reset
    } = useForm();
    const { data, mutate } = useSWR('setting', async () => await settingsModel.list())
    console.log('data------', data)
    useEffect(() => {

        reset(data?.data);
    }, [data])


    const onSubmit = handleSubmit(async (data, event) => {
        const formData = new FormData(event.target);
        await settingsModel.create(formData).then((response) => {

            // router.push('/pages')
        }).catch(error => {
            console.log('error', error)
            setError('title', { type: 'required', message: error.response?.data?.errors?.title })
            console.log(data?.errors?.title)
        })
    });

    return (
        <>
           <SettingsLayout title="Settings">

                <div className="row justify-content-center">
                    <div className="col-12 col-lg-10 col-xl-12 mx-auto">

                        <div>

                            <h5 className="mb-0 mt-3">Notifications Settings</h5>
                            <p>Select notification you want to receive</p>
                            <hr />
                            <strong className="mb-0">Security</strong>
                            <p>Control security alert you will be notified.</p>
                            <div className="list-group mb-5">
                                <div className="list-group-item">
                                    <div className="row align-items-center">
                                        <div className="col">
                                            <strong className="mb-0">Unusual activity notifications</strong>
                                            <p className="text-muted mb-0">Donec in quam sed urna bibendum tincidunt quis mollis mauris.</p>
                                        </div>
                                        <div className="col-auto">
                                            <div className="custom-control custom-switch">
                                                <Form>
                                                    <Form.Check
                                                        type="switch"
                                                        id="custom-switch"

                                                    />

                                                </Form>
                                                <span className="custom-control-label"></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="list-group-item">
                                    <div className="row align-items-center">
                                        <div className="col">
                                            <strong className="mb-0">Unauthorized financial activity</strong>
                                            <p className="text-muted mb-0">Fusce lacinia elementum eros, sed vulputate urna eleifend nec.</p>
                                        </div>
                                        <div className="col-auto">
                                            <div className="custom-control custom-switch">
                                                <Form>
                                                    <Form.Check
                                                        type="switch"
                                                        id="custom-switch"

                                                    />

                                                </Form>
                                                <span className="custom-control-label"></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <hr className="my-4" />
                            <strong className="mb-0">System</strong>
                            <p>Please enable system alert you will get.</p>
                            <div className="list-group mb-5">
                                <div className="list-group-item">
                                    <div className="row align-items-center">
                                        <div className="col">
                                            <strong className="mb-0">Notify me about new features and updates</strong>
                                            <p className="text-muted mb-0">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                                        </div>
                                        <div className="col-auto">
                                            <div className="custom-control custom-switch">
                                                <Form>
                                                    <Form.Check
                                                        type="switch"
                                                        id="custom-switch"

                                                    />

                                                </Form>
                                                <span className="custom-control-label"></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="list-group-item">
                                    <div className="row align-items-center">
                                        <div className="col">
                                            <strong className="mb-0">Notify me by email for latest news</strong>
                                            <p className="text-muted mb-0">Nulla et tincidunt sapien. Sed eleifend volutpat elementum.</p>
                                        </div>
                                        <div className="col-auto">
                                            <div className="custom-control custom-switch">
                                                <Form>
                                                    <Form.Check
                                                        type="switch"
                                                        id="custom-switch"

                                                    />

                                                </Form>
                                                <span className="custom-control-label"></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="list-group-item">
                                    <div className="row align-items-center">
                                        <div className="col">
                                            <strong className="mb-0">Notify me about tips on using account</strong>
                                            <p className="text-muted mb-0">Donec in quam sed urna bibendum tincidunt quis mollis mauris.</p>
                                        </div>
                                        <div className="col-auto">
                                            <div className="custom-control custom-switch">
                                                <Form>
                                                    <Form.Check
                                                        type="switch"
                                                        id="custom-switch"

                                                    />

                                                </Form>
                                                <span className="custom-control-label"></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>



            </SettingsLayout>
        </>
    );
};

export default Page;